export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/upload-82538b317592c9cfce3c86a3a8cd8473.svg";